var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-table",
        {
          attrs: { noDataText: "No data", data: _vm.localData },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, class: { "text-grey": tr.canceled_at } },
                    [
                      _vm.showCheckboxes
                        ? _c(
                            "vs-td",
                            [
                              _c("vs-checkbox", {
                                attrs: {
                                  checked: _vm.isCompanySelected(tr.company_id),
                                  disabled: Boolean(tr.canceled_at),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleCompanySelection(
                                      tr.company_id
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("vs-td", [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("span", [_vm._v(_vm._s(tr.company_name))]),
                            _vm.isFinalSecuredRow(tr)
                              ? _c(
                                  "vx-tooltip",
                                  { attrs: { text: "ASEGURADO" } },
                                  [
                                    _c(
                                      "vs-chip",
                                      {
                                        staticClass: "text-white",
                                        attrs: { color: "#0096f5" },
                                      },
                                      [_vm._v("ASEGURADO")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            tr.canceled_at
                              ? _c(
                                  "vs-chip",
                                  {
                                    staticClass: "text-white",
                                    attrs: { color: "#E86B73" },
                                  },
                                  [_vm._v("Anulada")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("vs-td", [
                        tr.file
                          ? _c(
                              "div",
                              { staticClass: "flex gap-2 items-center" },
                              [
                                _c("div", { staticClass: "mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { "padding-left": "10px" },
                                      attrs: {
                                        href: tr.file,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Ver\n                "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "flex-1" },
                                  [
                                    !tr.is_closed
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass:
                                              "cursor-pointer w-full",
                                            attrs: {
                                              size: "small",
                                              disabled:
                                                _vm.isActionDisabled(tr),
                                              color: "primary",
                                              transparent: "",
                                              icon: "move_to_inbox",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.closeOdc(tr)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Cerrar\n                "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "vs-button",
                                          {
                                            staticClass:
                                              "cursor-pointer w-full",
                                            attrs: {
                                              size: "small",
                                              transparent: "",
                                              color: "success",
                                              icon: "check",
                                              disabled: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Cerrada\n                "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex-1" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass: "cursor-pointer w-full",
                                        attrs: {
                                          size: "small",
                                          color: "primary",
                                          type: tr.email_send_at
                                            ? "border"
                                            : "filled",
                                          icon: "send",
                                          disabled: _vm.isSendDisabled(tr),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSendEmail(tr)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.emailButtonLabel(tr)) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm.canGenerateSecuredOdc(tr)
                          ? _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      size: "small",
                                      color: "primary",
                                      type: "filled",
                                      disabled: Boolean(tr.canceled_at),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.generateSecuredOdc(tr)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Generar ODC\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("div", { staticClass: "text-center" }, [
                              _c("span", [_vm._v("No hay archivo")]),
                            ]),
                      ]),
                      _c("vs-td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.dateFormatter(tr.created_at)) +
                            "\n        "
                        ),
                      ]),
                      _c(
                        "vs-td",
                        [
                          tr.id
                            ? _c("flat-pickr", {
                                attrs: {
                                  width: "100%",
                                  config: _vm.configDatePicker,
                                  placeholder: "Fecha de pago",
                                  disabled: _vm.isActionDisabled(tr),
                                },
                                on: {
                                  "on-close": function ($event) {
                                    return _vm.updatePaidAt(tr.id, $event)
                                  },
                                },
                                model: {
                                  value: tr.payment_date,
                                  callback: function ($$v) {
                                    _vm.$set(tr, "payment_date", $$v)
                                  },
                                  expression: "tr.payment_date",
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ],
                        1
                      ),
                      _c("vs-td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.dateFormatter(tr.start_period)) +
                            " - " +
                            _vm._s(_vm.dateFormatter(tr.end_period)) +
                            "\n        "
                        ),
                      ]),
                      _c(
                        "vs-td",
                        {
                          staticClass: "total-currency-column",
                          attrs: { id: `total-currency-column-${tr.id}` },
                        },
                        [
                          tr.id
                            ? _c(
                                "vs-select",
                                {
                                  attrs: {
                                    value: tr.currency,
                                    disabled: _vm.isActionDisabled(tr),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleCurrencyEdit(
                                        tr.id,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._l(_vm.currencies, function (currency) {
                                    return _c("vs-select-item", {
                                      key: currency.value,
                                      attrs: {
                                        value: currency.value,
                                        text: currency.text,
                                      },
                                    })
                                  }),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options",
                                    },
                                    [_vm._v("Nada que mostrar.")]
                                  ),
                                ],
                                2
                              )
                            : _c("span", [
                                _vm._v(_vm._s(_vm.displayCurrency(tr))),
                              ]),
                        ],
                        1
                      ),
                      _c(
                        "vs-td",
                        [
                          tr.id
                            ? _c("vs-input", {
                                attrs: {
                                  value: tr.total_amount,
                                  type: "number",
                                  min: "0",
                                  step: "0.01",
                                  disabled: _vm.isActionDisabled(tr),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleTotalAmountEdit(
                                      tr.id,
                                      $event
                                    )
                                  },
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(_vm.displayAmount(tr))),
                              ]),
                        ],
                        1
                      ),
                      _c("vs-td", [
                        tr.file && _vm.canUseFullActionRow(tr)
                          ? _c(
                              "div",
                              { staticClass: "flex justify-start gap-2" },
                              [
                                _c("vs-button", {
                                  attrs: {
                                    color: tr.canceled_at
                                      ? "warning"
                                      : "danger",
                                    title: tr.canceled_at
                                      ? "Recuperar"
                                      : "Anular",
                                    type: tr.canceled_at ? "filled" : "border",
                                    icon: tr.canceled_at
                                      ? "restore"
                                      : "not_interested",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleCancelOdc(tr)
                                    },
                                  },
                                }),
                                _c("vs-button", {
                                  attrs: {
                                    color: "primary",
                                    type: "filled",
                                    title: "Reemplazar",
                                    icon: "repeat",
                                    disabled: Boolean(tr.canceled_at),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReplaceOdcInput(tr)
                                    },
                                  },
                                }),
                                _c("input", {
                                  staticClass: "hidden",
                                  attrs: {
                                    type: "file",
                                    name: `replaceOdcInput-${tr.id}`,
                                    id: `replaceOdcInput-${tr.id}`,
                                    accept: "application/pdf",
                                  },
                                  on: { change: _vm.handleReplaceOdcUpload },
                                }),
                              ],
                              1
                            )
                          : _vm.canGenerateSecuredOdc(tr)
                          ? _c("div", [
                              _c("span", { staticClass: "text-grey" }, [
                                _vm._v("Pendiente de generar"),
                              ]),
                            ])
                          : _c("div", [_c("span", [_vm._v("-")])]),
                      ]),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _vm.showCheckboxes
                ? _c(
                    "vs-th",
                    { staticStyle: { width: "60px" } },
                    [
                      _c("vs-checkbox", {
                        attrs: { checked: _vm.allCompaniesSelected },
                        on: { change: _vm.handleSelectAllCompanies },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("vs-th", [_vm._v("Empresa de medios")]),
              _c("vs-th", [_vm._v("Archivos")]),
              _c("vs-th", [_vm._v("Fecha creación")]),
              _c("vs-th", [_vm._v("Fecha de pago")]),
              _c("vs-th", [_vm._v("Periodo")]),
              _c("vs-th", [_vm._v("Moneda")]),
              _c("vs-th", [_vm._v("Monto")]),
              _c("vs-th", { staticStyle: { width: "150px" } }, [
                _vm._v("Acción"),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }